import React from "react"

class SpinnerComponent extends React.Component {
    render() {
        return (
            <div className="fallback-spinner  vh-100 d-flex align-items-center justify-content-center">
                {/* <div className="d-flex">
                    <img src={logo} className="mr-auto ml-auto mt-2" style={{maxWidth: "200px"}} alt="شرکت توسعه نرم افزار باران"/>
                </div>*/}
                <div class="loader"></div>
            </div>
        )
    }
}

export default SpinnerComponent
